<template>
  <div class="container">
    <div class="center">
      <h1>Login As Admin User</h1>
      <div class="box">
        <div class="content">
          <span>Email:</span>
          <a-input placeholder="Your Email" v-model="email" />
        </div>
        <div class="content">
          <span>Password:</span>
          <a-input-password placeholder="Your Password" v-model="password" />
        </div>
        <a-button @click="handleLogin" type="primary">Login</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    ...mapActions({login:"user/login"}),
    async handleLogin() {
      if (this.email == "" || this.password == "") {
        return this.$message.error("please fill all part");
      }
      try {
        const res = await this.login({
          email: this.email,
          password: this.password
        });
        if (!res) {
          return this.$message.error("fail to login");
        }
        this.$router.push('/admin')
        this.$message.success("welcome !");
      } catch (e) {
        return this.$message.error("fail to login");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

}
.center {
  width: 30%;
  height: 50%;
  display: flex;
 flex-direction: column;
}
</style>